export default "__VITE_ASSET__B9fjz6Q1__"